export default __webpack_public_path__ + "static/media/abc2.3b470df5.jpg";